import { render, staticRenderFns } from "./changephone.vue?vue&type=template&id=7221e14c&scoped=true&"
import script from "./changephone.vue?vue&type=script&lang=js&"
export * from "./changephone.vue?vue&type=script&lang=js&"
import style0 from "./changephone.vue?vue&type=style&index=0&id=7221e14c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7221e14c",
  null
  
)

export default component.exports